import axios from 'axios'

import * as actions from "./index"

import * as auth from "../utils/auth"

import {toast} from "react-toastify";
import {push} from "connected-react-router";


export function login(username, password) {
  return function (dispatch) {
    dispatch({type: actions.AUTH_LOGIN.PENDING});
    axios.post("/login", auth.credentials(username, password))
      .then((response) => {
        toast.success("Successfully logged in")
        auth.set_token(response.data.token)
        //dispatch(push('/'))
        window.location.reload()
      })
      .catch((err) => {
        toast.error("Invalid credentials")
        //dispatch({type: actions.AUTH_LOGIN.ERROR, payload: err})
      })
  }
}

export function register(username, password) {
  return function (dispatch) {
    dispatch({type: actions.AUTH_LOGIN.PENDING});
    axios.post("/register", auth.credentials(username, password))
      .then((response) => {
        dispatch({type: actions.AUTH_LOGIN.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: actions.AUTH_LOGIN.ERROR, payload: err})
      })
  }
}

export function logout() {
  return function (dispatch) {
    dispatch({type: actions.AUTH_LOGOUT.PENDING});
    axios.get("/auth/logout")
      .then((response) => {
        localStorage.removeItem('token')
        dispatch({type: actions.AUTH_LOGOUT.SUCCESS, payload: response.data})
      })
      .catch((err) => {
        dispatch({type: actions.AUTH_LOGOUT.ERROR, payload: err})
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/authActions.js